module.exports = __webpack_public_path__ + "img/entrada_lobby.eec52645.jpg";